import { TankStatisticEntity, TankStatisticFilter } from '../../models'

export const SET_TANK_STATISTIC = 'SET_TANK_STATISTIC'
export const SET_TANK_STATISTIC_LOADED = 'SET_TANK_STATISTIC_LOADED'
export const SET_TANK_STATISTIC_FILTER = 'SET_TANK_STATISTIC_FILTER'

export interface TankStatisticState {
  tankStatistic: TankStatisticEntity[]
  isTankStatisticLoaded: boolean
  tankStatisticFilter: TankStatisticFilter
}

interface SetTankStatisticAction {
  type: typeof SET_TANK_STATISTIC
  payload: TankStatisticEntity[]
}

interface SetTankStatisticLoadedAction {
  type: typeof SET_TANK_STATISTIC_LOADED
  payload: boolean
}

interface SetTankStatisticFilterAction {
  type: typeof SET_TANK_STATISTIC_FILTER
  payload: TankStatisticFilter
}

export type TankStatisticAction =
  | SetTankStatisticAction
  | SetTankStatisticLoadedAction
  | SetTankStatisticFilterAction
